import React from 'react';

interface CountryCardSkeletonProps {}

const CountryCardSkeleton: React.FC<CountryCardSkeletonProps> = () => {
  return (
    <div className="rounded-2xl border overflow-hidden bg-white dark:bg-slate-800/50 border-gray-200 dark:border-gray-700 animate-pulse">
      {/* Header */}
      <div className="p-6 border-b border-gray-200 dark:border-gray-700">
        <div className="flex items-center gap-3 mb-4">
          <div className="w-12 h-12 rounded-xl bg-gray-200 dark:bg-slate-700"></div>
          
          <div className="flex-1">
            <div className="h-5 w-32 rounded-lg mb-2 bg-gray-200 dark:bg-slate-700"></div>
            <div className="h-4 w-24 rounded-lg bg-gray-200 dark:bg-slate-700"></div>
          </div>
        </div>
        
        <div className="flex gap-2">
          <div className="h-6 w-20 rounded-lg bg-gray-200 dark:bg-slate-700"></div>
          <div className="h-6 w-16 rounded-lg bg-gray-200 dark:bg-slate-700"></div>
        </div>
      </div>

      {/* Actions */}
      <div className="p-6 space-y-3">
        <div className="h-12 w-full rounded-xl bg-gray-200 dark:bg-slate-700"></div>
        <div className="h-12 w-full rounded-xl bg-gray-200 dark:bg-slate-700"></div>
      </div>
    </div>
  );
};

export default CountryCardSkeleton;
